export default function DisclaimerRibbon() {
    return (
        <div
            data-testid="disclaimer-ribbon"
            className="bg-charcoal text-gold/90 text-[10px] sm:text-[11px] py-2 px-4 text-center uppercase font-mono tracking-[0.25em] border-b border-white/5"
        >
            Demonstração fictícia · Projeto de design · Corte Nobre · João Pessoa — PB
        </div>
    );
}
